<template>
  <section class="derayah-faq faqs-section">
    <div class="section-title">
      <h2 class="main-title" data-aos="fade-down" data-aos-duration="500">
        الأسئلة الشائعة
      </h2>
    </div>
    <div class="container derayah-faq-desktop">
      <div class="row">
        <div class="col-md-6 accordion-col">
          <div class="accordion" id="faqAccordionLeft">
            <div
              class="accordion-item"
              data-aos="fade-up"
              data-aos-delay="50"
              data-aos-duration="500"
            >
              <h2 class="accordion-header" id="headingOne">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                >
                  ما هي شروط كشف الحساب؟
                  <i class="fa fa-chevron-down"></i>
                </button>
              </h2>
              <div
                id="collapseOne"
                class="accordion-collapse collapse"
                aria-labelledby="headingOne"
                data-bs-parent="#faqAccordionLeft"
              >
                <div class="accordion-body">محتوى الجواب هنا.</div>
              </div>
            </div>
            <div
              class="accordion-item"
              data-aos="fade-up"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              <h2 class="accordion-header" id="headingTwo">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  ما هو برنامج مساند؟
                  <i class="fa fa-chevron-down"></i>
                </button>
              </h2>
              <div
                id="collapseTwo"
                class="accordion-collapse collapse"
                aria-labelledby="headingTwo"
                data-bs-parent="#faqAccordionLeft"
              >
                <div class="accordion-body">محتوى الجواب هنا.</div>
              </div>
            </div>
            <div
              class="accordion-item"
              data-aos="fade-up"
              data-aos-delay="250"
              data-aos-duration="500"
            >
              <h2 class="accordion-header" id="headingThree">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  ما هي شروط التعريف بالراتب؟
                  <i class="fa fa-chevron-down"></i>
                </button>
              </h2>
              <div
                id="collapseThree"
                class="accordion-collapse collapse"
                aria-labelledby="headingThree"
                data-bs-parent="#faqAccordionLeft"
              >
                <div class="accordion-body">محتوى الجواب هنا.</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 accordion-col">
          <div class="accordion" id="faqAccordionRight">
            <div
              class="accordion-item"
              data-aos="fade-up"
              data-aos-delay="50"
              data-aos-duration="500"
            >
              <h2 class="accordion-header" id="headingFour">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFour"
                  aria-expanded="false"
                  aria-controls="collapseFour"
                >
                  ما هي المستندات المطلوبة لرفع طلب إصدار تأشيرة؟
                  <i class="fa fa-chevron-down"></i>
                </button>
              </h2>
              <div
                id="collapseFour"
                class="accordion-collapse collapse"
                aria-labelledby="headingFour"
                data-bs-parent="#faqAccordionRight"
              >
                <div class="accordion-body">محتوى الجواب هنا.</div>
              </div>
            </div>
            <div
              class="accordion-item"
              data-aos="fade-up"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              <h2 class="accordion-header" id="headingFive">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFive"
                  aria-expanded="false"
                  aria-controls="collapseFive"
                >
                  كيف يتم دفع رسوم إصدار التأشيرة؟
                  <i class="fa fa-chevron-down"></i>
                </button>
              </h2>
              <div
                id="collapseFive"
                class="accordion-collapse collapse"
                aria-labelledby="headingFive"
                data-bs-parent="#faqAccordionRight"
              >
                <div class="accordion-body">محتوى الجواب هنا.</div>
              </div>
            </div>
            <div
              class="accordion-item"
              data-aos="fade-up"
              data-aos-delay="250"
              data-aos-duration="500"
            >
              <h2 class="accordion-header" id="headingSix">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSix"
                  aria-expanded="false"
                  aria-controls="collapseSix"
                >
                  ما يجب على القيام به قبل التقديم على تأشيرة عمالة منزلية؟
                  <i class="fa fa-chevron-down"></i>
                </button>
              </h2>
              <div
                id="collapseSix"
                class="accordion-collapse collapse"
                aria-labelledby="headingSix"
                data-bs-parent="#faqAccordionRight"
              >
                <div class="accordion-body">محتوى الجواب هنا.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="derayah-mobile-faq container"
      data-aos="fade-down"
      data-aos-delay="200"
      data-aos-duration="1000"
    >
      <div class="faq-swiper swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="false"
                >
                  ما هو برنامج مساند؟
                  <i class="fa fa-chevron-down"></i>
                </button>
              </h2>
              <div id="collapseOne" class="accordion-collapse collapse">
                <div class="accordion-body">محتوى الجواب هنا.</div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                >
                  ما هي المستندات المطلوبة لرفع طلب إصدار تأشيرة؟
                  <i class="fa fa-chevron-down"></i>
                </button>
              </h2>
              <div id="collapseTwo" class="accordion-collapse collapse">
                <div class="accordion-body">محتوى الجواب هنا.</div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="false"
                >
                  ما يجب على القيام به قبل التقديم على تأشيرة عمالة منزلية؟
                  <i class="fa fa-chevron-down"></i>
                </button>
              </h2>
              <div id="collapseThree" class="accordion-collapse collapse">
                <div class="accordion-body">محتوى الجواب هنا.</div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="false"
                >
                  ما هو برنامج مساند؟
                  <i class="fa fa-chevron-down"></i>
                </button>
              </h2>
              <div id="collapseOne" class="accordion-collapse collapse">
                <div class="accordion-body">محتوى الجواب هنا.</div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                >
                  ما هي المستندات المطلوبة لرفع طلب إصدار تأشيرة؟
                  <i class="fa fa-chevron-down"></i>
                </button>
              </h2>
              <div id="collapseTwo" class="accordion-collapse collapse">
                <div class="accordion-body">محتوى الجواب هنا.</div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="false"
                >
                  ما يجب على القيام به قبل التقديم على تأشيرة عمالة منزلية؟
                  <i class="fa fa-chevron-down"></i>
                </button>
              </h2>
              <div id="collapseThree" class="accordion-collapse collapse">
                <div class="accordion-body">محتوى الجواب هنا.</div>
              </div>
            </div>
          </div>
        </div>
        <div class="faq-navigation">
          <div class="swiper-button-next mobile-faq-next">
            <i class="fas fa-chevron-right"></i>
          </div>
          <div class="swiper-button-prev mobile-faq-prev">
            <i class="fas fa-chevron-left"></i>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
